// extracted by mini-css-extract-plugin
export var cats = "Hero-module--cats--6c145";
export var hero = "Hero-module--hero--ac0bd";